import { render, staticRenderFns } from "./ServeItem.vue?vue&type=template&id=6835eb52&scoped=true&"
import script from "./ServeItem.vue?vue&type=script&lang=js&"
export * from "./ServeItem.vue?vue&type=script&lang=js&"
import style0 from "./ServeItem.vue?vue&type=style&index=0&id=6835eb52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835eb52",
  null
  
)

export default component.exports